import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WarehouseDayXMLResponse } from 'src/app/models/advance-transfer.model';

@Component({
  selector: 'app-modal-warehouse-days-xml',
  templateUrl: './modal-warehouse-days-xml.component.html',
  styleUrls: ['./modal-warehouse-days-xml.component.scss']
})
export class ModalWarehouseDaysXmlComponent {
  @Output() close = new EventEmitter<string>();
  @Input() xml: WarehouseDayXMLResponse[] = [];
  @Input() isXMLE = false;
  @Input() companyName = "";

}
